var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('select-product'),_c('widget-catalog'),_c('widget-brands'),_c('widget-about'),_c('widget-trust'),_c('widget-articles'),_c('widget-map')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }